module.exports = __webpack_public_path__ + "media/images/iconPlus__inactive-61f9adeded7641052d096706ac0ed294.png";